import { render, staticRenderFns } from "./UserProfileTabs.vue?vue&type=template&id=22ecc837&scoped=true&"
import script from "./UserProfileTabs.vue?vue&type=script&lang=js&"
export * from "./UserProfileTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ecc837",
  null
  
)

export default component.exports